// extracted by mini-css-extract-plugin
module.exports = {"contextMenuButton":"ProfilesTableRowMenu_contextMenuButton__3jfyc","contextMenu":"ProfilesTableRowMenu_contextMenu__1kogV","contextIcon":"ProfilesTableRowMenu_contextIcon__tC2un"};